"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var icons_1 = __importDefault(require("../../../assets/icons"));
var CircularProgress_1 = require("../CircularProgress/CircularProgress");
var Icon_1 = require("../Icon/Icon");
var Link_1 = require("../Link/Link");
var Tooltip_1 = require("../Tooltip/Tooltip");
var Button_logic_1 = require("./Button.logic");
/**
 * Button atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-buttons-button--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Button Source}
 */
exports.Button = (0, react_1.forwardRef)(function (_a, ref) {
    var title = _a.title, variant = _a.variant, onClick = _a.onClick, icon = _a.icon, isLoading = _a.isLoading, className = _a.className, isDisabled = _a.isDisabled, width = _a.width, url = _a.url, openLinkInNewTab = _a.openLinkInNewTab, tooltip = _a.tooltip, stopPropagation = _a.stopPropagation, expanded = _a.expanded, tooltipPlacement = _a.tooltipPlacement;
    var _b = (0, Button_logic_1.useButton)({
        isDisabled: isDisabled,
        isLoading: isLoading,
        variant: variant,
        icon: icon,
        width: width,
        url: url,
        onClick: onClick,
        stopPropagation: stopPropagation,
        expanded: expanded,
    }), classes = _b.classes, disabled = _b.disabled, iconColor = _b.iconColor, textColor = _b.textColor, component = _b.component, handleClick = _b.handleClick, isTextVariant = _b.isTextVariant;
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: tooltip, placement: tooltipPlacement }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1.default)(className, classes.tooltipWrapper, disabled && !isLoading && classes.disabled) }, { children: renderInnerContent() })) })));
    function renderInnerContent() {
        return url ? ((0, jsx_runtime_1.jsx)(Link_1.Link, __assign({ "aria-disabled": disabled, className: classes.layoutRoot, disabled: disabled, onNavigate: handleClick, openInNewTab: openLinkInNewTab, role: 'button', url: url }, { children: renderBase() }))) : (renderBase());
    }
    function renderBase() {
        return ((0, jsx_runtime_1.jsxs)(core_1.Button, __assign({ "aria-disabled": !url && disabled, className: (0, classnames_1.default)(classes.layoutRoot, classes.root, classes.variant), component: component, disableRipple: true, disabled: disabled, onClick: url ? undefined : handleClick, ref: ref, role: url ? undefined : 'button', style: { color: textColor } }, { children: [isLoading ? renderSpinner() : renderIcon(), isTextVariant ? (0, jsx_runtime_1.jsx)("span", { children: title }) : title, renderExpandIcon()] })));
    }
    function renderSpinner() {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.icon, "data-testid": 'button-spinner' }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.CircularProgress, { color: iconColor, size: 16 }) })));
    }
    function renderIcon() {
        return icon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icon, color: iconColor, className: classes.icon, "data-testid": 'button-icon' });
    }
    function renderExpandIcon() {
        if (expanded === undefined) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.chevronDown, color: iconColor, className: (0, classnames_1.default)(classes.expandIcon, expanded && classes.expandIconExpanded), "data-testid": 'expand-icon' }));
    }
});
